module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-paytable-selected@1x.png?0.0.53";